import React from 'react';
import classnames from 'classnames';

import './style.scss';

export default ({ children, vertical }) => (
  <dl className={classnames({ vertical })}>{children}</dl>
);

export const Description = ({
  field,
  value,
  highlighted = false,
  className,
  ...props
}) => (
  <>
    <dt className={classnames(className)} {...props}>
      <strong>{field}</strong>
    </dt>
    <dd className={classnames(className, { highlighted })}>{value}</dd>
  </>
);
